module.exports = __webpack_public_path__ + "static/media/brunch1.829afd54.png";